<template>
  <div class="MedicinePicker">
    <div v-for="({name, id}, i) in _value" :key="id" class="item">
      <div class="field-wrap">
        <TextInput placeholder="薬名" :value="name" @input="v => setValue(i, v)" />
      </div>
      <button type="button" @click="removeValue(i)" class="remove">
        <i class="fas fa-minus"></i>
      </button>
    </div>
    <button type="button" class="add" @click="addValue"><i class="fas fa-plus"></i> 薬の種類を追加</button>
  </div>
</template>

<script>
import TextInput from '@/components/atoms/TextInput'
import moment from 'moment'

export default {
  name: 'MedicinePicker',
  components: {
    TextInput,
  },
  data() {
    return {
      lifeCount: 0,
    }
  },
  props: {
    value: {
      type: Array,
      default: () => [''],
    },
  },
  computed: {
    _value() {
      return (this.value || ['']).map((name, i) => ({name, id: `${this.lifeCount}-${i}`}))
    },
  },
  methods: {
    setValue(i, v){
      const newValue = this._value.map((item, curI) => curI === i ? v : item.name)
      this.$emit('input', newValue)
    },
    addValue(){
      this.$emit('input', this._value.map(o => o.name).concat(['']))
    },
    removeValue(i){
      if (this.value[i] && !window.confirm(`${this.value[i]} を削除しますか?`)) {
        return
      }
      const newValue = this.value.filter((_, i2) => i2 !== i)
      if (newValue.length===0) newValue.push('')
      this.$emit('input', newValue)
      this.lifeCount += 1
    },
  },
}
</script>

<style scoped lang="scss">
.MedicinePicker {
}
.item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.field-wrap {
  flex: 1;
}
.remove {
  border-radius: 50%;
  width: 30px;
  font-size: 10px;
  text-align: center;
}
.add {
  font-size: 12px;
  padding: 5px 0;
}
</style>
